import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';

import "../src/design/app.scss";

import store from '@/state/store'
import App from './App.vue'
import i18n from './i18n'
import { initAxiosBackend } from './helpers/axios'


Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueSweetalert2);

const axiosConfig = {
  baseURLApi1: process.env.VUE_APP_API1_URL,
  baseURLApi2: process.env.VUE_APP_API2_URL,
  baseURLApi3: process.env.VUE_APP_API3_URL,
  baseURLApi4: process.env.VUE_APP_API4_URL,
  baseURLMubinApi: process.env.VUE_APP_API_MUBIN_URL,
};

initAxiosBackend(axiosConfig);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
